import { pathURL } from '@/components/constants/urls';
import { usePropertyDetailContext, useUserLanguage } from '@/customHooks';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Button, IncidentStatusOptionPill, PriorityPill, RowSpacer } from '../atoms';
import { Col, Row } from 'react-grid-system';
import textsData from '@/textData/PropertyDetailTexts.json'
import { capitalizeFirstLetter, incidentCategoryMapper, incidentTypeMapper } from '@/helpers';
import { advancedNormalizeDate } from '@/helpers/normalizeDate';

const StyledGridTable = styled.div`
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 160px;
`

const StyledGridHeader = styled.div`
  display: contents;
  & > div {
    font-weight: bold;
    text-align: left;
    padding: 15px;
    border-top: 1px solid grey;
    border-bottom: 1px solid gray;
  }
`

const StyledGridRow = styled.div`
  display: contents;

  & > div {
    padding: 15px;
    font-size: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    align-self: stretch;
    place-content: center;
    border-bottom: solid 1px lightgray;
    background-color: ${({ theme }) => theme.colors.light};
  }

  &:nth-of-type(odd) > div {
    background-color: ${({ theme }) => theme.colors.background2};
  }
`

const URL_TO_NAVIGATE_FOR_CREATING = `/${pathURL.USER}/${pathURL.INCIDENTS}/${pathURL.CREATE}`
const URL_TO_NAVIGATE_FOR_DETAILS = `/${pathURL.USER}/${pathURL.INCIDENTS}/${pathURL.DETAIL}`

export const PropertyDetailIncidentsList = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.incidentsList : textsData.en.incidentsList

  const navigate = useNavigate()
  
  const { property } = usePropertyDetailContext()
  const incidents = property?.incidents ?? [];

  const onDeatilsClickHandle = (id: string) => {
    navigate(URL_TO_NAVIGATE_FOR_DETAILS, { state: { id } })
  }
  
  if (incidents.length === 0) {
    return (
      <>
        <RowSpacer height={3} />
        <Row>
          <Col>
            <span><b>{texts.noData.table}</b></span>
          </Col>
        </Row>
      </>
    )
  }
  
  return (
    <>
      <RowSpacer height={1} />
      <Row justify="end" align="center">
        <Col xs='content'>
          <Button
            onClick={() => navigate(URL_TO_NAVIGATE_FOR_CREATING)}
          >
            {texts.addButton}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          {
            incidents.length === 0
            ? <p><b>{texts.noData.table}</b></p>
            : (
              <StyledGridTable>
                {/* Encabezado */}
                <StyledGridHeader>
                  <div>{texts.tableHeader.column1}</div>
                  <div>{texts.tableHeader.column5}</div>
                  <div>{texts.tableHeader.column2}</div>
                  <div>{texts.tableHeader.column3}</div>
                  <div>{texts.tableHeader.column4}</div>
                  <div>{texts.tableHeader.column6}</div>
                  <div></div>
                </StyledGridHeader>

                {/* Filas dinámicas */}
                {incidents.map((data) => (
                  <StyledGridRow key={data.id}>
                    <div>{capitalizeFirstLetter(data.unity?.name ?? texts.noData.unity)}</div>
                    <div>{advancedNormalizeDate(userLanguage, data.endDate)}</div>
                    <div>{incidentTypeMapper(data.incidentTypeOption, userLanguage)}</div>
                    <div><PriorityPill option={data.priorityOption} /></div>
                    <div>{incidentCategoryMapper(data.incidentCategoryOption, userLanguage)}</div>
                    <div><IncidentStatusOptionPill option={data.statusOption} /></div>
                    <div>
                      <Button
                        secondary
                        upperCased
                        onClick={() => onDeatilsClickHandle(data.id)}
                      >
                        {texts.rowButton}
                      </Button>
                    </div>
                  </StyledGridRow>
                )) ?? null}
              </StyledGridTable>
            )
          }
        </Col>
      </Row>
    </>
  );

}